import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { KTSVG } from "../../../smallnation/helpers"
import { PageTitle } from "../../../smallnation/layout/core"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
import moment from "moment";
import $ from 'jquery';
import { Link } from 'react-router-dom';
import {  useHistory } from "react-router-dom";
//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const SchoolList: FC = () => {
      const intl = useIntl()
      let history = useHistory();
      const ITEMS_PER_PAGE = 10; // Per page show the data pagination
      const [totalItems, setTotalItems] = useState(0);
      const [totalpages, settotalPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(1);
      const [schools, setschoollist] = useState([]);
      const Pagesize=10;
      useEffect(() =>
      {
        //getSchoolList();
        filterSchoolList(ITEMS_PER_PAGE,1);
        //getJobTypeList(ITEMS_PER_PAGE,'1');

      },[]);
      const filterSchoolList = (ITEMS_PER_PAGE,pageNumber) => {

        var searchTxt:any = $('#search_input').val();
        var encoded_queryval = encodeURIComponent(searchTxt.trim());
        var siteIdIn = "2";
        const requestObject={
          "siteId" : 2,
          "sortBy":"update_On",
          "sortDir":"desc",
          "searchTxt":encoded_queryval,
          "pageNumber":pageNumber,
          "pageSize":ITEMS_PER_PAGE
       }
       var accessTokenIn=sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
                    //'Authorization': "Bearer "+accessTokenIn
                    //'Authorization': accessTokenIn
                  },
          body: JSON.stringify(requestObject)
        };
        services.getSchoolnDatapag(requestOptions).then((res) =>
        {
          $(".paginationContent").show();
          setTotalItems(res.totalElements);
          settotalPages(Math.ceil(res.totalElements / ITEMS_PER_PAGE));
          setCurrentPage(pageNumber);

          var contAr = res.content;

          if(res){
            setschoollist(res);
            }

        });
}
const searchList = () => {
  filterSchoolList(ITEMS_PER_PAGE,'1');
}
const [popup, setPopup] = useState({
  show: false, // initial values set to false and null
  id: null,
});
const handleDelete = (id) => {
  setPopup({
    show: true,
    id,
  });
};
const handleDeleteTrue = () => {
  alert('here');
};

// This will just hide the Confirmation Box when user clicks "No"/"Cancel"

const handleDeleteFalse = () => {
  setPopup({
    show: false,
    id: null,
  });
};
/*const deleteSchool = () => {
  if (confirm("Are you sure you want to delete the school?")) {
      // your deletion code
      var schoolid = $('#schoolid').val();
      const requestObject={
        "schoolId":schoolid,
      }
      console.log(requestObject);
      var accessTokenIn=sessionStorage.getItem("adminAccToken");
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',
                  //'Authorization': "Bearer "+accessTokenIn
                  //'Authorization': accessTokenIn
                },
        body: JSON.stringify(requestObject)
      };

      services.adminDeleteSchool(requestOptions).then((res) =>
      {
        history.push('/schoollist');
      });
  }
} */
      const handlePageChange2 = (offset,triggerevent) => {
        // alert(offset);
        filterSchoolList(ITEMS_PER_PAGE,offset);
      };

      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'School List'})}</PageTitle>

        <div className={`card`}>

      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
        <table className=''>
            <thead>
              <tr className='fw-bolder text-muted pb-3 '>
                <th  style={{minWidth:"450px"}}><input type="text" id="search_input" name="search_input" className="form-control" placeholder="" onChange={searchList}/> </th>
                <th className='min-w-140px'> <button type="button" onClick={searchList} className="btn btn-primary" style={{maxWidth: "135px"}}> Search </button></th>
              </tr>
            </thead>
            </table>
          {/* begin::Table */}
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bolder text-muted'>
                {/*<th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-13-check'
                    />
                  </div>
                </th> */}
                <th className='min-w-140px'>School Name</th>
               {/* <th className='min-w-140px'>Address</th>*/}
                <th className='min-w-140px'>Phone Number</th>
                <th className='min-w-140px'>Email ID</th>
                <th className='min-w-100px text-end'>Actions</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>

            {
	          schools.map((data, index) => (
              <tr>
               {/* <td>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input className='form-check-input widget-13-check' type='checkbox' value='1' />
                  </div>
                </td> */}
                <td>
                  {/* <a href={`/editschool?schoolId=`+data.schoolId} className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
                  {data.name}</a> */}

                  <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={`/editschool?schoolId=`+data.schoolId}>{(data.name=='' || data.name==null) ? '--' : data.name}</Link>

                </td>
               {/* <td>
                  <a href={`/editschool?schoolId=`+data.schoolId} className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>

                  {data.address} {data.address1} {data.city} {data.state} {data.zip}
                  </a>

                </td> */}
                <td>
                  {/* <a href={`/editschool?schoolId=`+data.schoolId} className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
                  {data.phone}</a> */}

                  <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={`/editschool?schoolId=`+data.schoolId}>{(data.phone=='' || data.phone==null) ? '--' : data.phone}</Link>

                </td>
                <td>
                  {/* <a href={`/editschool?schoolId=`+data.schoolId} className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
                  {data.email}</a> */}

                  <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={`/editschool?schoolId=`+data.schoolId}>{(data.email=='' || data.email==null) ? '--' : data.email}</Link>

                </td>


                <td className='text-end d-flex justify-content-end'>

                  {/* <a
                    href={`/editschool?schoolId=`+data.schoolId}
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                  >
                    <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                  </a> */}




                  <input type="hidden" id="schoolid" value={data.schoolId}/>
                  <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={`/editschool?schoolId=`+data.schoolId}> <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' /></Link>

                  <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 mx-2 fs-6' to={`/deleteschool?schoolId=`+data.schoolId}> <KTSVG path='/media/icons/duotune/art/art011.svg' className='svg-icon-3' /></Link>

                </td>
              </tr>
              ))}

            </tbody>
            {/* end::Table body */}
          </table>

          <Pagination

                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={handlePageChange2}

                />

          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>



        </>
      )
    }
export {SchoolList}